import {
  Card as CardParent,
  Divider as DividerParent,
  gutter,
  layers,
  media,
  spacing,
} from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

export const LinkProxy = styled.a`
  text-decoration: none;
`;

export const Wrapper = styled(CardParent)`
  width: calc(100% - ${gutter.default} * 2);
  position: relative;
  padding: ${spacing.small} ${spacing.medium};
  margin: ${spacing.xxlarge} ${gutter.default};

  ${media.greaterThan('tablet')`
    margin: calc(${spacing.xxlarge} + 17rem) ${gutter.default} ${spacing.xxlarge};
    width: 100%;
    height: 30rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 0;
    margin-right: 0;
    margin-left: 0;
  `};
`;

export const Content = styled.div`
  position: relative;
  text-align: left;
  z-index: ${layers.default};

  ${media.greaterThan('tablet')`
    display: grid;
    gap: ${spacing.small};
    min-width: 50rem;
    text-align: center;
  `}
`;

export const Typography = styled.div``;

export const CardThumbnailDivider = styled.div`
  position: absolute;
  top: -55%;
  left: 50%;
  transform: translate(-50%, 0);
`;

interface WaterMarkWrapperProps {
  variant: 'top' | 'bottom';
}

const waterMarkModifiers = {
  top: css`
    top: -7rem;
    right: 0;
    transform: rotate(180deg);
  `,
  bottom: css`
    bottom: -7rem;
    left: 0;
  `,
};

export const WaterMarkWrapper = styled.div<WaterMarkWrapperProps>`
  position: absolute;
  ${({ variant }) => waterMarkModifiers[variant]};
`;

// TODO: Use next/image.
export const ImageWrapper = styled.div`
  position: absolute;
  right: -${spacing.medium};
  top: 50%;
  transform: translateY(-50%);
`;

export const Divider = styled(DividerParent)`
  width: 100%;
  height: 8rem;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: ${layers.under};
`;
